import api from "../../Environment";

/**
 * Phase B unified search client.
 */

export async function unifiedSearch(query, params = {}) {
  try {
    const response = await api.postMethod("search/unified", {
      key: query,
      q: query,
      ...params,
    });
    const body = response && response.data;
    if (body && body.success) {
      return body.data || { items: [], indexes: {} };
    }
  } catch (e) {
    /* ignore */
  }
  return { items: [], indexes: {}, suggestions: [] };
}

export async function searchAutocomplete(query, params = {}) {
  try {
    const response = await api.postMethod("search/autocomplete", {
      key: query,
      q: query,
      ...params,
    });
    const body = response && response.data;
    if (body && body.success && body.data) {
      return body.data.suggestions || [];
    }
  } catch (e) {
    /* ignore */
  }
  return [];
}

export async function searchRecent(params = {}) {
  try {
    const response = await api.postMethod("search/recent", params);
    const body = response && response.data;
    if (body && body.success && body.data) {
      return body.data.recent || [];
    }
  } catch (e) {
    /* ignore */
  }
  return [];
}

export async function searchIndexes() {
  try {
    const response = await api.postMethod("search/indexes", {});
    const body = response && response.data;
    if (body && body.success && body.data) {
      return body.data.indexes || [];
    }
  } catch (e) {
    /* ignore */
  }
  return [];
}
